import React, { useState } from "react";
import { HomeFleetLanding } from "./components/HomeFleetLanding";
import { HomeFleetApp } from "./components/HomeFleetApp";
import { ResetPasswordScreen } from "./components/ResetPasswordScreen";
import { DealerResponseScreen } from "./components/DealerResponseScreen";

export default function HomeFleet(){
  const[resetToken]=useState(()=>new URLSearchParams(window.location.search).get("reset"));
  const[dealToken]=useState(()=>new URLSearchParams(window.location.search).get("deal"));
  const[authed,setAuthed]=useState(()=>sessionStorage.getItem("hf_auth")==="1");
  if(resetToken)return <ResetPasswordScreen token={resetToken}/>;
  // Before the auth gate, deliberately. The person holding this link is a
  // dealer with no HomeFleet account, and bouncing them to a sign-in screen
  // would make the feature unusable. Their token is the entire credential
  // and it authorises exactly one action on one deal -- see
  // functions/_lib/dealLinks.js. Nothing here reads or writes hf_auth, so
  // opening a dealer link never disturbs a session already signed in on
  // the same browser.
  if(dealToken)return <DealerResponseScreen token={dealToken}/>;
  if(!authed)return <HomeFleetLanding onUnlock={()=>setAuthed(true)}/>;
  return <HomeFleetApp onSignOut={()=>{sessionStorage.removeItem("hf_auth");setAuthed(false);}}/>;
}
